import $ from 'jquery';

export default function ({ container }) {
    if (!container) {
        throw new Error('no root element');
    }

    $(container).addClass('userContent');
}
